import * as React from "react";
import { SVGProps } from "react";

const Blackcoin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 2000" {...props}>
    <defs>
      <linearGradient
        id="a"
        x1={644.29}
        x2={1409.37}
        y1={434.17}
        y2={1514.28}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#deb354" />
        <stop offset={1} stopColor="#c89550" />
      </linearGradient>
    </defs>
    <circle cx={1024.15} cy={970.43} r={794.31} fill="url(#a)" />
    <path d="M1124.8 885c64.36-83.68 44.14-241.15-33.79-295s-160-26.89-175.87-11.73S900 946.63 900 946.63s160.43 22.08 224.8-61.63m11.94 150.35c-60.23-26.21-236.77-19.31-236.77-19.31s-2.74 89.19 3.67 256.1 63.46 166 122.77 168.28 172.43-1.84 209.67-145.76-39.08-233.08-99.34-259.28" />
    <path d="M1000 0C447.72 0 0 447.72 0 1000s447.72 1000 1000 1000 1000-447.71 1000-1000S1552.29 0 1000 0m406.19 719.74c2.75 166.9-142.77 213.8-142.77 213.8s59.31-57.32 56.55-204.13-113.1-219.32-113.1-219.32 196.57 42.75 199.32 209.65m-654.26 784.14-201.39 9.66v-18.39s123.23-12.42 123.23-228.51v-552.2c0-183-123.23-214.72-123.23-214.72v-16.54l201.39 9.64v1011.06m321.84 10.34c-87.59.7-250.13-11.26-250.13-11.26V494.22c107.14-1.39 144.61-15.87 232.88-3.46s164.15 98.63 184.84 184.84-1.37 168.28-29.67 213.1-90.34 75.88-90.34 75.88 93.8 31.72 126.92 59.3 97.24 102.76 72.41 266.22-159.33 223.44-246.92 224.12m232.78-37.22s95.5-81.39 91.3-246.41-91.3-242.59-91.3-242.59 179.64 44.15 181.7 240.7-181.7 248.3-181.7 248.3" />
  </svg>
);

export default Blackcoin;
